import ValuationForm from "@components/forms/ValuationForm"
import CloseIcon from "@components/icons/CloseIcon"
import React, { useState, useEffect } from "react"
import { Modal } from "react-bootstrap"
import { graphql, useStaticQuery, Link } from "gatsby"
import { parseHTML } from "@lib/utils"
import { useLocation } from "@reach/router"
import "./PopupForms.scss"

const GlobalFormModal = () => {
  const data = useStaticQuery(graphql`
      query {
        strapiGlobalModule {
          show_popup
          show_popup_form
          popup_form_pages
          popup_form {
            strapi_id
            formname
            title_content {
              data {
                title_content
              }
            }
            image {
              url
              alternativeText
            }
            cta 
            link
            mail 
          }
        }
      }
    `)

  const popup_form = data?.strapiGlobalModule?.popup_form
  const { pathname } = useLocation();
  let popup_form_pages = data?.strapiGlobalModule?.popup_form_pages;
  let show_popup = data?.strapiGlobalModule?.show_popup;
  let show_popup_form = data?.strapiGlobalModule?.show_popup_form;
  const { title_content, image, cta, mail, link, formname } = popup_form;
  const [show, setShow] = useState(false)
  const [render, setRender] = useState(false)
  const handleClose = () => {
    setShow(false);
    localStorage.setItem('popup', 'closed');
  }
  useEffect(() => {
    let isMatch = false;
    
    if (popup_form_pages == "all") {
      isMatch = true;
    }else if (popup_form_pages) {
      let splitSlug = (popup_form_pages) ? popup_form_pages?.split(',') : [];
      pathname.split('/').map((slug) => {
        if (slug && splitSlug.includes(slug)) {
          isMatch = true;
        }
      })
    } 

    if(link && link == location.href){
      isMatch = false;
    }
    if(localStorage.getItem('popup')){
      isMatch = false;
    }

    setTimeout(() => {
      if (isMatch && show_popup && !render) {
        setShow(isMatch)
        setRender(isMatch)
      }
    }, 20000)
  })
  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      className="popup-form-modal"
    >
      <Modal.Body className="popup-form-modal-body">
        <Link to={link} className="popup-form-modal-img-section">
          <img
            src={image?.url}
            alt=""
            className="joinus-img"
          />
        </Link>

        <div className="popup-form-modal-content">
          <CloseIcon onClick={handleClose} color="secondary" />
          <div className="content-section">
            {parseHTML(title_content?.data.title_content)}
          </div>
          {show_popup_form &&
            <ValuationForm cta={cta} toEmail={mail} formname={formname} />
          }
          {!show_popup_form &&
            <Link to={link} className="button button-primary w-100 mt-4">{cta}</Link>
          }

        </div>
      </Modal.Body>
    </Modal>
  )
}

export default GlobalFormModal
